// selectors.js
import { createSelector } from 'reselect';

const getMaterialData = (state) => state.MaterialData.material;
const getEmployeeData = (state) => state.EmployeeData.employee;
const getMatInwardData = (state) => state.MatInwardData.stkValue;


export const selectMaterials = createSelector(
  [getMaterialData],
  (material) => material || { data: [] }
);

export const selectEmployees = createSelector(
  [getEmployeeData],
  (employee) => employee || { data: [] }
);

export const selectMatInwardData = createSelector(
  [getMatInwardData],
  (stkValue) => stkValue || { data: [] }
);


const getZones = (state) => state.ZoneData.zones;
export const selectZones = createSelector(
  [getZones],
  (zone) => zone || { data: [] }
);


const getLocations = (state) => state.LocationData.locdata;
export const selectLocations = createSelector(
  [getLocations],
  (zone) => zone || { data: [] }
);

const getlocation = (state) => state.LocationData.locdata2;
export const selectlocationdata = createSelector(
  [getlocation],
  (locdata) => locdata || { data: [] }
);

const getstkInw = (state) => state.stkInwData.stkdata;
export const selectStkInwdata = createSelector(
  [getstkInw],
  (zone) => zone || { data: [] }
);

const getStkItems = (state) => state.stkInwData.stkItems;
export const selectStockItems = createSelector(
  [getStkItems],
  (zone) => zone || { data: [] }
);

// const getStkItemsList = (state) => state.stkInwData.stkItems;
// export const selectStockItemsList = createSelector(
//   [getStkItemsList],
//   (zone) => zone || { data: [] }
// );

const getStockItemSize = (state) => state.stockData.itemsize;
export const selectStkItemSize = createSelector(
  [getStockItemSize],
  (zone) => zone || { data: [] }
);

const getCommonStkReg = (state) => state.stockData.comStk;
export const selectCommonStockReg = createSelector(
  [getCommonStkReg],
  (zone) => zone || { data: [] }
);

const getAdminSale = (state) => state.stockData.adsale;
export const selectAdminSaleData = createSelector(
  [getAdminSale],
  (zone) => zone || { data: [] }
);

const getStudentSale  = (state) => state.stockData.studsale;
export const selectStudentSaleData  = createSelector(
  [getStudentSale],
  (zone) => zone || { data: [] }
);

const getCancelAdminData = (state) => state.stockData.cancelAd;
export const selectCancelAdminData = createSelector(
  [getCancelAdminData],
  (zone) => zone || { data: [] }
);

const getUserSale = (state) => state.stockData.ursale;
export const selectUserSaledata = createSelector(
  [getUserSale],
  (zone) => zone || { data: [] }
);

const getUserStkInw = (state) => state.stkInwData.ustkdata;
export const selectUstkInwdata = createSelector(
  [getUserStkInw],
  (zone) => zone || { data: [] }
  
);
const getUserStkRTInw = (state) => state.userReturn.ustkdata;//edited by murli
export const selectUstkInwdata1 = createSelector(
  [getUserStkRTInw],
  (zone) => zone || { data: [] }
);
const getStkmemo = (state) => state.stkInwData.smemo;
export const selectStkMemo = createSelector(
  [getStkmemo],
  (locdata) => locdata || { data: [] }
);


const getschlStkDetails = (state) => state.stkInwData.ustkdetails;
export const selectSchlStkDetails = createSelector(
  [getschlStkDetails],
  (zone) => zone || { data: [] }
);

const getStudents = (state) => state.ZoneData.studs;
export const selectStudents = createSelector(
  [getStudents],
  (zone) => zone || { data: [] }
);

const getsubuser = (state) => state.ZoneData.subUser;
export const selectSubUser = createSelector(
  [getsubuser],
  (zone) => zone || { data: [] }
);


const getUserPages = (state) => state.ZoneData.pages;
export const selectUserPages = createSelector(
  [getUserPages],
  (zone) => zone || { data: [] }
);